import { render, staticRenderFns } from "./DataToHourTemplateComponent.vue?vue&type=template&id=796dd68c&lang=pug"
import script from "./DataToHourTemplateComponent.vue?vue&type=script&lang=ts"
export * from "./DataToHourTemplateComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('796dd68c')) {
      api.createRecord('796dd68c', component.options)
    } else {
      api.reload('796dd68c', component.options)
    }
    module.hot.accept("./DataToHourTemplateComponent.vue?vue&type=template&id=796dd68c&lang=pug", function () {
      api.rerender('796dd68c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/grids/ColumnTemplates/DataToHourTemplateComponent.vue"
export default component.exports